import { api } from "@/frontend/services/api";
import type {
  CreateSubCategoryRequestDTO,
  UpdateSubCategoryRequestDTO,
  SubCategoryResponseDTO,
  SubCategoriesPaginatedResponseDTO,
  ApiResponse,
  PaginationRequestDTO,
} from "@/shared/dto";

const BASE_URL = "/sub-categories/private";

export const subCategoryService = {
  getPaginate: (params?: PaginationRequestDTO) =>
    api.getWithParams<ApiResponse<SubCategoriesPaginatedResponseDTO>>(BASE_URL, params),
  getById: (id?: string) =>
    api.get<ApiResponse<SubCategoryResponseDTO>>(`${BASE_URL}/${id}`),
  create: (data: CreateSubCategoryRequestDTO) =>
    api.post<ApiResponse<SubCategoryResponseDTO>>(BASE_URL, data),
  update: (id: string, data: UpdateSubCategoryRequestDTO) =>
    api.put<ApiResponse<SubCategoryResponseDTO>>(`${BASE_URL}/${id}`, data),
  delete: (id: string) =>
    api.delete<ApiResponse<void>>(`${BASE_URL}/${id}`),
};
